import type { MaasNodeGroupsBlockOptions } from '@/delivery-type-plugin/capabilities/maas-node-groups/types';
import { registerCapability } from '@/delivery-type-plugin/platform/capability-registry';
import type { CapabilityProps } from '@/delivery-type-plugin/platform/capability-registry/types';

import { MiKvOffloadNodesBlock } from './MiKvOffloadNodesBlock';

function MiKvOffloadCapability({ form, options }: CapabilityProps<MaasNodeGroupsBlockOptions>) {
  return <MiKvOffloadNodesBlock form={form} options={options} />;
}

registerCapability<MaasNodeGroupsBlockOptions>({
  key: 'mi-kv-offload',
  fields: [],
  component: MiKvOffloadCapability,
  defaultPaths: () => ({}),
  resolvePaths: () => ({}),
});
